<template>
  <header-middle></header-middle>
  <!-- <img />  -->
  <div class="container">
    <h1 class="text-center my-4">قوانین و مقررات</h1>
    <div class="my-4 text-center">
      <img src="https://radap.ir/imagesUploaded/main/rulls.jpg" alt="قوانین و مقررات" />
    </div>
    <h3>ماده ۱ - تعاریف و اصطلاحات</h3>
    <p>
      اصطلاحاتی که در این شرایط و قوانین به کار رفته است دارای معانی مشروح زیر است:
      <br />
      ۱-۱- شرکت:شرکت تجارت الکترونیک راد جام با برند تجاری راداَپ .
      <br />
      ۱-۲- راداَپ : خدمات نرم‌افزاری که توسط شرکت به منظور خریدمایحتاج روزانه و کسب درآمد
      به کاربران ارائه می‌شود.
      <br />
      ۱-۳- سایت راداَپ : خدمات نرم‌افزاری که توسط شرکت و با همکاری طرف تجاری و روی سایت
      راداَپ به کاربران ارائه می‌شود.
      <br />
      ۱-۴- اپلیکیشن: نرم‌افزار متعلق به شرکت که به منظور استفاده از خدمات راداَپ یا سایت
      راداَپ ، حق استفادۀ موقت از آن برابر شرایط مندرج در قرارداد خصوصی و سند حاضر به
      کاربران یا طرف‌های تجاری شرکت اعطا می‌شود.
      <br />
      ۱-۵- قرارداد خصوصی: توافق کتبی یا الکترونیکی فی‌مابین شرکت و کاربر راننده یا طرف‌های
      تجاری شرکت، جهت بهره‌برداری موقت از نرم‌افزار راداَپ .
      <br />
      ۱-۶- کاربر: شخصی حقیقی یا حقوقی است اعم از، راننده و کاربر عادی که برابر شرایط و
      قوانین حاضر از طریق اینترنت به سایت متصل و از خدمات راداَپ یا سایت راداَپ بهره مند
      میشود.
      <br />
      ۱-۷- کاربران: از کاربر راننده، کاربر عادی یا سایر کاربران سایت راداَپ ، تحت عنوان
      کاربران یاد می‌شود.
      <br />
      ۱-۸- کاربر راننده پیک: شخص حقیقی است که در سایت راننده راداَپ برای دریافت درخواست
      سفر و ارائۀ خدمات ثبت‌‌نام کرده ‌است.
      <br />
      ۱-۹- کاربر : شخص حقیقی یا حقوقی است که در سایت برای ارسال درخواست خرید ثبت‌‌نام
      کرده‌ است.
      <br />
      ۱-۱۱- طرف تجاری: اشخاص حقیقی و حقوقی که برابر قرارداد خصوصی از طریق ایجاد درگاه، حق
      بهره‌برداری موقت از سایت را با نام تجاری خود یا مشترک با راداَپ دارند.
      <br />
      ۱-۱۲- حساب کاربری: حسابی است که اشخاص برای استفاده از خدمات راداَپ یا سایت راداَپ
      ایجاد کرده‌اند.
      <br />
      ۱۳-۱- کد تخفیف: کد صادر و تامین اعتبار شده توسط راداَپ که برابر آن کاربر مسافر می
      تواند با وارد کردن در اپلیکیشن از پرداخت کل یا قسمتی از هزینه خرید معاف می شود.
      <br />
      ۱۴-۱- کد تخفیف : کد صادر شده توسط راداَپ و تامین اعتبار شده توسط مدیر پنل سازمانی
      راداَپ که برابر آن کاربر راداَپ می تواند با وارد کردن در اپلیکیشن از پرداخت کل یا
      قسمتی از هزینه خرید معاف می شود.
      <br />
      ۱۵-۱- مدیر پنل سازمانی: شخص حقیقی یا حقوقی که حق استفاده از پنل سازمانی راداَپ ، جهت
      انجام مدیریت را دارد.
      <br />
      ۱-۱۶- موجودی: مبلغی است که کاربران در حساب کاربری خود به منظور استفاده از خدمات
      راداَپ یا سایت راداَپ دارند. این مبلغ به صورت پرداخت از طریق سامانۀ بانکی و کارتهای
      عضو شبکۀ شتاب و یا با استفاده طبق شرایط و قوانین حاضر منظور و محاسبه خواهد شد.
      <br />
      ۱-۱۷- اطلاعات محرمانه: اطلاعاتی که توسط کاربران در راداَپ یا سایت راداَپ قرار داده
      می‌شود، اعم از اطلاعاتی که به صورت مستقیم از سوی کاربران وارد می‌شود و همچنین
      اطلاعاتی که به صورت خودکار و در نتیجۀ بهره‌برداری از خدمات راداَپ یا سایت راداَپ
      توسط شرکت یا طرف‌های تجاری تولید یا در اختیار شرکت قرار داده می‌شود.
      <br />
      ۱-۱۸- قوانین و مقررات جمهوری اسلامی ایران: قانون اساسی، قوانین عادی، آئین‌نامه‌های
      اجرایی، بخشنامه‌ها، دستورالعمل‌ها و کلیه ضوابط قانونی حاکم بر انجام موضوع قرارداد
      اعم از قانون بیمه اجباری شخص ثالث، آئین نامه راهنمائی و رانندگی و قانون رسیدگی به
      تخلفات رانندگی.
    </p>
    <h3>ماده ۲ - حساب کاربری</h3>
    <p>
      ۲-۱- کاربران با ثبت‌نام در سایت راداَپ ، همچنین با هر بار استفاده از خدمات آن،
      می‌پذیرند که شرایط و قوانین حاضر را به صورت کامل مطالعه کرده و آن را با اطلاع کامل
      از شرایط و معانی‌اش پذیرفته‌اند. این شرایط و قوانین ممکن است در طول زمان تغییر کند.
      استفادۀ کاربران از سایت، پس از هر بار تغییر در شرایط و قوانین، به معنی پذیرش تغییرات
      مذکور است. این قوانین برای مطالعه کاربران در سایت راداَپ در دسترس است.
      <br />
      ۲-۲- برای استفاده از خدمات راداَپ یا سایت راداَپ لازم است که هر کاربر اعم از شخص
      حقیقی یا حقوقی یک حساب کاربری در سایت بسازد. تنها اشخاصی که بیش از ۱۸ سال سن دارند و
      واجد اهلیت قانونی هستند می‌توانند اقدام به ساخت حساب کاربری در سایت کنند. کاربر
      مذکور برای استفاده از خدمات باید نام، نام خانوادگی، آدرس پست الکترونیکی و شماره
      همراه خود را در سایت راداَپ ثبت کند.
      <br />
      تبصره ۱- کاربران در صورت نیاز به استفاده از خدمات سایت راداَپ باید برای تکمیل
      اطلاعات خواسته شده توسط طرف‌های تجاری از قبیل نشانی اقدام کنند.
      <br />
      تبصره ۲- ثبت نام کاربران الزامی است به داشتن حساب کاربری در راداَپ لیکن برای استفاده
      از خدمات سایت راداَپ می بایست واجد اهلیت قانونی از جمله حداقل سن ۱۸ سال باشد.
      <br />
      ۲-۳- کاربران شخص حقوقی مکلف به معرفی نماینده (شخص حقیقی) برای ثبت‌نام در اپلیکیشن
      هستند و اطلاعات این شخص حقوقی باید در سایت قید شود.
      <br />
      ۲-۴- هیچ یک از کاربران حق استفاده از ربات و نرم‌افزارهای مرتبط یا واسط را برای
      استفاده از سایت اعم از احراز هویت، تکمیل اطلاعات، ارسال درخواست و غیره ندارند.
      <br />
      ۲-۵- کاربران می‌پذیرند کلیه اطلاعات درخواستی سایت را مطابق با واقعیت، صحیح و به‌‌روز
      وارد کنند و شخص کاربر مسئول عدم صحت و به‌ روز نبودن اطلاعات است. در صورت اثبات خلاف
      این موضوع، شرکت هیچ گونه مسئولیتی در مورد خسارات و مشکلات ناشی از عدم اعتبار اطلاعات
      اعلامی بر عهده نخواهد داشت.
      <br />
      ۲-۶- کاربران متعهد می‌شوند که صرفا با ایمیل متعلق به خود در سایت ثبت‌نام کنند. در
      غیر این صورت در برابر شخص ذی‌نفع صاحب ایمیل تماما مسئول بوده و شرکت به محض آگاهی از
      این موضوع مجاز خواهد بود نسبت به لغو عضویت و حساب کاربری اقدام کند.
      <br />
      ۲-۷- هر شخص تنها می‌تواند یک حساب کاربری به عنوان کاربر یا کاربر راننده یا
      استفاده‌کننده از خدمات سایت راداَپ داشته باشد. در صورتی که شرکت اطلاع یابد که به نام
      یک شخص اعم از حقیقی و یا حقوقی حساب‌های کاربری متعدد وجود دارد، مجاز خواهد بود نسبت
      به قطع خدمات و غیرفعال کردن حساب‌های کاربری مذکور اقدام کند.
      <br />
      ۲-۸- مسئولیت همۀ فعالیت‌هایی که از طریق حساب کاربری اشخاص حقیقی و یا حقوقی در راداَپ
      یا سایر خدمات ارائه شده در سایت راداَپ انجام می‌شود، به عهدۀ کاربران است. بنابراین
      مسئولیت اشخاص ثالث یا افرادی غیر از کاربر که با آن حساب از خدمات سایت استفاده
      می‌کنند، تماما متوجه کاربر صاحب‌حساب است. کاربر دارای حساب کاربری ، دارای مسئولیت
      تضامنی در قبال اشخاص اعم از شرکت، سایر کاربران و اشخاص ثالث هستند.
      <br />
      ۲-۹- مسئولیت حفظ امنیت اطلاعات حساب کاربری شامل نام کاربری و رمز عبور به عهدۀ
      کاربران می‌باشد. در صورت مفقود شدن یا به سرقت رفتن اطلاعات حساب کاربری و گوشی
      موبایل، کاربر مذکور موظف است در اسرع وقت موضوع را به اطلاع شرکت برساند. بدیهی است تا
      زمانی که اطلاع‌رسانی به شرکت انجام نشده است، مسئولیت همۀ فعالیت‌هایی که از طریق حساب
      کاربری مذکور و موبایل کاربر انجام شده و می‌شود به عهدۀ وی خواهد بود.
      <br />
      ۲-۱۰- کاربران حق ندارند به سایر اشخاص حقیقی و حقوقی اجازه استفاده از حساب کاربری خود
      را بدهند یا حساب خود را به شخص حقیقی یا حقوقی دیگری منتقل کنند. در مورد کاربر شخص
      حقوقی نیز، مسئولیت‌های قانونی بهره‌برداری از خدمات راداَپ یا سایت راداَپ متوجه
      مدیران اشخاص حقوقی خواهد بود.
      <br />
      ۲-۱۱- در شرایط خاصی ممکن است از کاربران برای استفاده از خدمات، درخواست احراز هویت
      شود، در این شرایط اگر کاربران اطلاعات کافی در اختیار شرکت قرار ندهند، شرکت می‌تواند
      حساب کاربری آن‌ها را مسدود و از ارائۀ خدمات به نامبردگان خودداری کند.
      <br />
      ۲-۱۲- ممکن است بنا به مورد و حسب صلاحدید شرکت، از کاربران درخواست شود که اقدام به
      تکمیل اطلاعات، ارائه مدارک و یا اصلاح اطلاعات موجود کنند. در این صورت، کاربر متعهد
      به ارائه اطلاعات و یا اصلاح اطلاعات درخواستی در مدت اعلام و درخواست شده از سوی شرکت
      خواهد بود. در غیر این صورت شرکت می‌تواند حساب کاربری وی را مسدود کرده و از ارائۀ
      خدمات به کاربر مذکور خودداری کند.
      <br />
      ۲-۱۳- اطلاعات کاربری نزد کاربر گیرنده اطلاعات، محرمانه بوده و هیچ یک از کاربران حق
      ندارند اطلاعات مربوط به حساب طرف مقابل را (اعم از مشخصات هویتی، شماره تماس، آدرس،
      عکس و غیره) ذخیره، یا منتشر کند و در دسترس دیگران قرار دهد.در صورت مشخص شدن انتشار
      یا ایجاد مزاحمت یا هر موردی که باعث خدشه دار شدن وجهه سایت راداَپ یا کاربر شود،
      اقدامات قانونی لازم از سمت مراجع قضایی انجام میپذیرد
      <br />
      ۲-۱۴- کاربر با داشتن حساب کاربری درخواست استفاده از راداَپ را داشته و خواهد داشت.
      کاربر در زمان استفاده از خدمات راداَپ متعهد به رعایت ضوابط راداَپ از جمله شرایط و
      قوانین حاضر است.
    </p>
    <h3>ماده ٣ - مسئولیت راداَپ</h3>
    <p>
      ١_٣- شرکت و طرف‌ تجاری با تمام امکانات خود از جمله مرکز تماس ۲۴ ساعته، واحد رسیدگی
      به شکایات و فرایند میانجیگری، تمامی تلاش خود را برای جلب رضایت کاربران و رفع هرگونه
      اختلاف احتمالی بین آنها در زمان استفاده از خدمات راداَپ وسایت راداَپ به کار
      می‌گیرند.
      <br />
      ٢-٣-شرکت و طرف تجاری با استفاده از نظارت‌های خود و انجام نظرسنجی از کاربران در
      انتهای یک خرید تلاش می‌کند خدمات با کیفیت مطلوب به کاربران ارائه دهد.
      <br />
      ٣-٣- شرکت و طرف تجاری برای فراهم کردن امکان استفاده از خدمات نرم‌افزاری توسط
      دستگاه‌های کاربران تلاش می‌کنند، اما تضمینی نسبت به اجرا شدن آن روی همۀ دستگاه‌ها یا
      شبکه‌های ارتباطی (اینترنت، شبکۀ تلفن‌ همراه و …) نخواهد داد.
      <br />
      ۴_٣- اطلاعات کاربران به عنوان اطلاعات محرمانه نزد شرکت و طرف تجاری محافظت شده و
      دسترسی به آن توسط اشخاص ثالث ممنوع بوده، مگر برابر قانون و تصمیم مقام ذیصلاح قضایی.
      بنابراین در موارد قانونی و هم‌چنین درخواست و صدور دستور مقتضی از سوی مراجع قضایی،
      شرکت مکلف به ارائۀ اطلاعات کاربران به مراجع مذکور است. لازم به توضیح است که ارائه
      اطلاعات کاربری صرفا از طریق سایت امکان‌پذیر است و به منظور حفظ امنیت اطلاعات کاربران
      و اصل محرمانگی، ارائه اطلاعات کاربری به خود کاربر و اشخاص ثالث به صورت تلفنی و حضوری
      مقدور نیست، مگر به حکم قانون.
      <br />
      ۵-٣- چنان‌چه هر یک از کاربران راداَپ در زمان استفاده از خدمات آن با مشکلی مواجه شوند
      برابر شرایط فوق می‌توانند شکایت خود را از طریق مرکز تماس ۲۴ ساعته و واحد رسیدگی و
      پشتیبانی راداَپ مطرح کنند. شرکت یا طرف تجاری پیگیری لازم را بنا به مورد انجام خواهد
      داد و تلاش خود را جهت حل و فصل اختلافات به‌عمل خواهد آورد.
      <br />
      ۶-٣- همۀ اطلاعات مورد نیاز کاربران درباره نحوه و شرایط ارائه خدمات راداَپ وسایت
      راداَپ و استفاده از نرم‌افزار‌های ارائه‌دهنده خدمات اعم از پنل مدیریت و راننده پیک،
      توسط شرکت و طرف تجاری در سایت قرار داده شده است. اشخاص با مراجعه به کانال روبیکا
      می‌توانند به قسمت مذکور و مطالعۀ آن‌ کاملا با شرایط ذکر شده و خدمات راداَپ یا سایت
      راداَپ آشنا شوند. همچنین همکاران شرکت در مرکز تماس به صورت ۲۴ ساعته پاسخگوی هرگونه
      ابهام و سوال کاربران هستند.
      <br />
      ۵-۷- مسئولیت شرکت و طرف تجاری فقط در فرضی متصور است که کاربران از طریق سایت اقدام به
      اخذ خدمات از جمله ارسال درخواست و قبول توسط کاربر دیگر کرده باشند. لذا اگر کاربر و
      پیک فروشگاه یا راداَپ که در سایت راداَپ ثبت‌نام کرده‌اند خارج از سایت با یکدیگر بر
      انجام کار توافق کنند هیچ‌گونه مسئولیتی متوجه شرکت نخواهد بود.
      <br />
      ۵-۸- طرف‌ تجاری استفاده‌کننده از خدمات سایت راداَپ به صورت مستقل و بر اساس شرایط و
      قوانین منتشر شده درسایت خود اقدام به ارائه خدمات می‌کند. استفاده از خدمات طرف‌ تجاری
      از طریق راداَپ توافق مستقلی فی مابین کاربران و طرف تجاری ارائه‌دهنده خدمات بوده و
      طرف تجاری بر اساس شرایط و قوانین و قراردادهای خود مسئول پاسخگویی به کاربران است.
      راداَپ صرفا ارائه‌دهنده خدمات به طرف تجاری بوده و نسبت به خدمات ارائه شده توسط طرف
      تجاری به کاربران مسئولیتی نخواهد داشت.
    </p>
    <h3>ماده ۴ -هزینه هاو پرداخت</h3>
    <p>
      ۴-۱- کاربران می‌پذیرند امکان استرداد هزینه‌هایی که بر اساس شرایط استفاده از خدمات
      سایت به شرکت یا طرف تجاری می‌پردازند وجود ندارد. شرکت و طرف تجاری مغایرت در هزینه
      اعلامی و پرداخت شده را تنها در ۴۸ ساعت اولیه رسیدگی می‌کنند. بنابراین کاربران باید
      موضوع را در همان ۴۸ ساعت اولیه به اطلاع شرکت و طرف تجاری برسانند. در غیر اینصورت
      راداَپ هیچگونه مسئولیتی در قبال این مسئله نخواهد داشت
      <br />
      ۴-۲- کاربران می‌پذیرند هزینۀ خرید اعلام شده از سوی شرکت، ممکن است بسته به شرایط
      فروشگاه از جمله نبود جنس، زمان ارسال، مدت زمان تخمینی رسیدن محصول، مبدا، مقصد و
      مسافت ، تغییرات اعلام شده در حین انجام کار و یا عوامل دیگر متغیر باشد. رقم اعلام شده
      از سوی شرکت بر اساس استانداردهای قیمت‌گذاری شرکت تعیین شده است و در صورت پذیرش آن از
      سوی کاربران حق طرح هیچگونه ادعا و اعتراضی درباره آن وجود نخواهد داشت.
    </p>
    <h3>ماده ۵ - قطع خدمات</h3>
    <p>
      شرکت یا طرف تجاری به هر دلیلی به این نتیجه برسد که حضور هر یک از کاربران اعم از
      راننده پیک یا کاربر سایت یا مهمان می تواند امنیت و آرامش کسب و کار و یا دیگر کاربران
      را در معرض تهدید قرار دهد، طبق صلاحدید خود مجاز به مسدود کردن حساب کاربر مذکور یا
      عدم اجازه استفاده از خدمات به صورت موقتی یا دائم است. اگر کاربران تعهدات این شرایط و
      قوانین را رعایت نکنند یا دسترسی آنها به خدمات راداَپ یا طرف تجاری خطرناک باشد یا
      مطلوب نباشد، شرکت حق حذف دسترسی کاربر مذکور را به خدمات راداَپ یا سایت راداَپ دارد.
      در این صورت، کاربر حق طرح هیچگونه ادعا و یا اعتراضی را نخواهد داشت.
      <br />
      ماده ۶ -محتوای تولید شده توسط کاربران
      <br />
      شرکت یا طرف تجاری ممکن است در شرایطی به کاربران اجازه دهند که در وب سایت، نرم‌افزار
      موبایل، شبکه‌های اجتماعی و یا سایر بخش‌های این سامانه، عکس، متن، فایل صوتی، فایل
      تصویری یا فایل‌های مشابه منتشر کنند. مالکیت این مطالب همچنان متعلق به کاربران خواهد
      بود. اما با ثبت آن‌ها در خدمات‌ مرتبط به راداَپ ، کاربران این حق را به شرکت یا طرف
      تجاری می‌دهند که اطلاعاتی را که از حالت محرمانه خارج شده است، منتشر کنند و یا به
      اشخاص حقیقی یا حقوقی دیگر منتقل کنند.
    </p>
    <h3>ماده ۶_موارد فنی</h3>
    <p>
      ١-٧- کاربران حق ندارند هیچ‌گونه تلاشی در جهت استخراج سورس کد Source Code
      نرم‌افزارهای راداَپ و سایت راداَپ شامل دیکامپایل Decompile، مهندسی معکوس Reverse
      Engineering یا فعالیت‌های مشابه انجام دهند، مگر اینکه اجازۀ چنین کاری به صورت قانونی
      صادر شده باشد.
      <br />
      ٢-٧- کاربران مجاز نیستند با استفاده از روش‌هایFraming یا Mirroring و روش‌های دیگر،
      نسخۀ دیگری از خدمات راداَپ را روی سرورهای دیگر ارائه کنند. همچنین کاربر مجاز نیست در
      نرم‌افزار راداَپ یا سایت راداَپ یا در روش ارائۀ خدمات تغییر یا اخلالی ایجاد کند.
      <br />
      ٣-٧- کاربران حق ندارند نرم‌افزار یا اسکریپتی با هدف ایندکس‌گذاری (Indexing)، مطالعه
      یا هرگونه فعالیت داده‌کاوی روی خدمات اجرا کنند.
      <br />
      ۴-٧- کاربران حق ندارند هیچ فعالیتی در راستای حصول دسترسی غیرقانونی و غیرمتداول به
      هیچ بخش یا سامانه‌های مرتبط با راداَپ انجام دهند.
    </p>
    <h3>ماده ٧ -توافق از راه دور</h3>
    <p>
      ۱-٨- کاربران توافق می‌کنند برای مبادلۀ آسان اطلاعات و انجام توافقات جدید، همۀ
      تغییرات و الحاقیه‌های شرایط و قوانین حاضر اعم از تغییر و اضافه کردن شروط آن، تنظیم
      قراردادها، اخطاریه‌ها و ابلاغیه‌های مربوط به شرکت یا طرف تجاری، از طریق سایت راداَپ
      به‌عمل آید و کاربران ضمن پذیرش اطلاع از شرایط و روند اجرایی توافق از راه دور و به
      صورت الکترونیکی، موافقت خود را نسبت به اعمال هرگونه شرایط و توافق جدید را از طریق
      فضای مجازی و به صورت الکترونیکی اعلام می‌کنند.
      <br />
      ٢- ٨_حساب کاربری متعلق به شخص کاربر و استفاده از آن قائم به شخص کاربر و غیر قابل
      انتقال است. کلیه مسئولیت‌های مربوط به حفظ و حراست از حساب کاربری برعهدۀ کاربر دارای
      حساب کاربری است. کاربران ضمن پذیرش کلیه مسئولیت ناشی از استفاده حساب کاربری، همۀ
      داده پیام‌های صادره از طریق حساب کاربری مذکور اعم از شکل، عبارت، تاییدیه، انتخاب
      اشکال و تایید آنها را منتسب به خود دانسته و هرگونه ادعایی نسبت به انکار، تردید و جعل
      داده پیام‌های ارسال شده از ناحیۀ کاربران غیر قابل استماع و مردود است.
      <br />
      ٣-٨- کاربران می‌پذیرند هرگونه رویه، اشکال، عبارات مبین تایید و اعلام قبولی و تصدیق
      داده پیام‌های صادره از طرف شرکت یا طرف تجاری به منزله امضا الکترونیکی و قبولی محسوب
      می‌شود و هرگونه ادعایی نسبت به امضا و قبولی مذکور غیر قابل استماع و مردود است.
      <br />
      ۴-٨- کاربران با عضویت در خدمات راداَپ و سایت راداَپ و استفاده از آن قصد و اراده خود
      را نسبت به پذیرش انعقاد هرگونه اقدام و عمل حقوقی از جمله عقود و معاملات از راه دور و
      از طریق سامانۀ رایانه‌ای و الکترونیکی اعلام می‌کنند.
      <br />
      ۵-٨- کلیه رویه‌های حقوقی و فنی اعم از احراز هویت کاربر، ایجاب و قبول، امضای
      الکترونیکی و تاییدیه‌های مرتبط ارائه‌شده توسط شرکت یا طرف تجاری جهت انعقاد قرارداد
      الکترونیکی با کاربران از طریق سایت، مورد قبول کاربران بوده و هرگونه روش فنی جهت
      تنظیم قرارداد از جمله ایجاب و قبول به مثابه توافق کتبی است. هرگونه ادعایی اعم از
      انکار و تردید نسبت به قرارداد الکترونیکی غیر قابل استماع و مردود است.
      <br />
      ۶-٨- با توجه به انعقاد قرارداد حاضر به صورت الکترونیکی و در فضای مجازی، کاربران
      موافقت خود را نسبت به تعیین اقامتگاه شرکت و طرف تجاری، به عنوان محل انعقاد قرارداد،
      اعلام میکند.
      <br />
      ٧-٨- کاربری که در سایت راداَپ ثبت نام میکند قبول میکند که ممکن است پیامک هایی از طرف راداَپ جهت اطلاع رسانی از تخفیف ها و خدمات راداَپ برای وی ارسال گردد و حق هرگونه اعتراض از وی سلب می شود. شماره های رسمی شرکت جهت اطلاع رسانی 09028121270 ،05252524850 و دیگر سرشماره های معتبر شرکت های تبلیغاتی و همچنین راداَپ نیز متعهد می شود متن پیام کاملاً در چارچوب قوانین جمهوری اسلامی باشد.
    </p>
    <p class="mt-3">تاريخ بروزرسانی ۲۰ بهمن ۱۴۰۱</p>
  </div>
  <grid-template></grid-template>
  <footer-template></footer-template>
</template>

<script>
import HeaderMiddle from "../section/header/header.vue";
import GridTemplate from "../section/footer/grids.vue";
import FooterTemplate from "../section/footer/footer.vue";
export default {
  components: {
    HeaderMiddle,
    GridTemplate,
    FooterTemplate,
  },
  name: "RullsPage",
};
</script>

<style scoped>
p {
  letter-spacing: 0 !important;
}
</style>
